<p-toast position="top-right"></p-toast>
<div class="layout-rightpanel app-rightpanel-tecfolk-fix" [ngClass]="{'layout-rightpanel-active': app.rightPanelActive}" (click)="app.onRightPanelClick()">
    <p-scrollPanel #scrollRightPanel [style]="{height: '100%'}">
        <div class="layout-rightpanel-wrapper">
            <div class="layout-rightpanel-header">
                <div class="weather-day">{{dateCheck | date: 'EEEE'}}</div>
                <div class="weather-date">{{dateCheck | date: 'MMMM dd'}}</div>
            </div>

            <div class="layout-rightpanel-content">
                <p-tabView>
                    <p-tabPanel [header]='setLabel("memberDuesHeaderLabel")'>
                        <div style="position:relative; " class="layout-rightpanel-content-defaulter-count">
                            <h1>{{setLabel("memberDuesLabel")}}</h1>
                            <div style="display: flex; flex-direction: column; gap:18px; margin-left:34px; margin-top: 15px;">
                            <div class="search-main">
                                <span style="color: #000000 !important; margin-right: 6px;">{{setLabel("fromLabel")}}</span>
                                <p-calendar class="p-calendar-from" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="from" [placeholder]='setLabel("fromDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#000000'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getDefaulters()">
                                </p-calendar>
                            </div>
                            <div class="search-main">
                                <span style="color: #000000 !important; margin-right: 21px;">{{setLabel("toLabel")}}</span>
                                <p-calendar class="p-calendar-to" [yearNavigator]="true" yearRange="1950:2040"
                                    [monthNavigator]="true" [(ngModel)]="to" [placeholder]='setLabel("toDatePlaceholderLabel")'
                                    [inputStyle]="{'color':'#000000'}" name="joinDate" [inline]="false"
                                    dateFormat="dd/mm/yy" [showIcon]="true" (onSelect)="getDefaulters()">
                                </p-calendar>
                            </div>
                            </div>
                            <h4>{{setLabel("totalDefaulterLabel")}} {{members.length}}</h4>
                            <button [disabled]="loading" [pTooltip]='setLabel("refreshTooltipLabel")'
                                style="width:40px;height:30px;position: absolute;padding-top: 7px;right: 0;top: 0;"
                                (click)="getAllMembersNotifications()"
                                class="refreshBtn p-button p-widget p-state-default p-corner-all p-button-text-only">
                                <p-progressSpinner *ngIf="loading"
                                    [style]="{width: '30px', height: '30px', position: 'relative', top: '-7px', left: '-8px'}"
                                    strokeWidth="8" fill="#2f4050" animationDuration=".5s"></p-progressSpinner>
                                <i style="top: -2px;position: relative;" *ngIf="!loading" class="fa fa-refresh"
                                    aria-hidden="true"></i>
                            </button>
                        </div>
                        <div style="position:relative; ">
                            <span style="position: absolute;top: 6px;left: 6px;"><i class="fa fa-search"
                                    style="line-height: 1.25;"></i></span>
                            <input type="text" (keyup)="searchLocal(name)" [(ngModel)]="name" pInputText
                                [placeholder]='setLabel("searchMemberPlaceholderLabel")' style="width: 100%;padding-left: 25px;height: 30px;">
                        </div>
                        <br>
                        <ul class="weekly-weather" *ngIf="members.length > 0" style="margin-top: 0 !important;">
                            <li *ngFor="let member of members">
                                <span [routerLink]="['/members/member', member.customerId,{defaulter:'true'}]"
                                    style="display: flex;cursor: pointer;flex-grow: 1;justify-content: space-between; padding-right:10px; align-items: center;">
                                    <span pTooltip="{{member.name}}" tooltipPosition="top" id="one"
                                        style="width: 100px;">{{member.name}}-{{member.tagNumber}}</span>
                                    <span id="two" style="margin-right: 10px;">{{member.fee | number:'1.0-0'}}</span>
                                    <span id="three" class="weekly-weather-value">{{member.defaulterDate |
                                        date: 'dd/MM/yyyy'}}</span>
                                </span>
                                <button pButton [pTooltip]='setLabel("feeMessageBeSentTooltipLabel")' tooltipPosition="bottom" type="button"
                                style="background-color: #25D366; margin: 3px 3px 3px 3px;" *ngIf="!memeberSetting && member.messageCount == 0"
                                class="p-button" icon="fa fa-whatsapp" (click)="openWhatsApp(member)"></button>

                                <button pButton [pTooltip]="'Fee reminder message sent ' + member.messageCount + ' times'" tooltipPosition="bottom" type="button"
                                style="background-color: #808080; margin: 3px 3px 3px 3px;" *ngIf="!memeberSetting && member.messageCount > 0"
                                class="p-button" icon="fa fa-whatsapp" (click)="openWhatsApp(member)"></button>

                                <button pButton [pTooltip]='setLabel("deleteTooltipLabel")' tooltipPosition="top" type="button"
                                    *ngIf="!memeberSetting " class="p-button-danger p-button" icon="fa fa-times"
                                    (click)="deleteDefaulter(member)"></button>
                            </li>
                        </ul>
                        <ul class="weekly-weather" *ngIf="members.length === 0">
                            <li>{{setLabel("noDuesLabel")}}</li>
                        </ul>
                    </p-tabPanel>
                    <!-- <p-tabPanel header="Trainer Dues">
                        <div style="position:relative; ">
                            <h1>Trainer Dues</h1>
                            <h4>Total Trainers: {{trainers.length}}</h4>
                            <button [disabled]="loading" pTooltip="Refresh"
                                style="width:40px;height:30px;position: absolute;padding-top: 7px;right: 0;top: 0;"
                                (click)="getAllTrainersNotifications()"
                                class="p-button p-widget p-state-default p-corner-all p-button-text-only">
                                <p-progressSpinner *ngIf="loading"
                                    [style]="{width: '30px', height: '30px', position: 'relative', top: '-7px', left: '-8px'}"
                                    strokeWidth="8" fill="#2f4050" animationDuration=".5s"></p-progressSpinner>
                                <i style="top: -2px;position: relative;" *ngIf="!loading" class="fa fa-refresh"
                                    aria-hidden="true"></i>
                            </button>
                        </div>
                        <div style="position:relative; ">
                            <span style="position: absolute;top: 6px;left: 6px;"><i class="fa fa-search"
                                    style="line-height: 1.25;"></i></span>
                            <input type="text" (keyup)="searchTrainerLocal(name)" [(ngModel)]="name" pInputText
                                placeholder="Search Member..." style="width: 100%;padding-left: 25px;height: 30px;">
                        </div>
                        <br>
                        <ul class="weekly-weather" *ngIf="trainers.length > 0" style="margin-top: 0 !important;">
                            <li *ngFor="let member of trainers">
                                <span [routerLink]="['/members/member', member.customerId,{defaulter:'true'}]"
                                    style="display: flex;cursor: pointer;flex-grow: 1;justify-content: space-between; padding-right:10px; align-items: center;">
                                    <span pTooltip="{{member.name}}" tooltipPosition="top" id="one"
                                        style="width: 100px;">{{member.name}}</span>
                                    <span id="two">{{member.fee}}</span>
                                    <span id="three">{{member.defaulterDate | date: 'dd/MM/yyyy'}}</span>
                                </span>
                                <button pButton pTooltip="Delete" tooltipPosition="top" type="button"
                                    *ngIf="!memeberSetting" class="p-button-danger p-button" icon="fa fa-times"
                                    (click)="deleteTrainerDefaulter(member)"></button>
                            </li>
                        </ul>
                        <ul class="weekly-weather" *ngIf="trainers.length === 0">
                            <li>No Dues</li>
                        </ul>
                    </p-tabPanel> -->
                </p-tabView>
            </div>
        </div>
    </p-scrollPanel>
</div>